import { MenuGroupContent, MenuOption } from "@smartsuite/react-ui/lib";

import type { LeftSource } from "./types";

export const ConditionSourceOptions: React.FC<{
  sources: LeftSource[];
  onSelect: (source: LeftSource) => void;
}> = ({ sources, onSelect }) => (
  <MenuGroupContent search={false}>
    {sources.map((source) => (
      <MenuOption
        key={source.hash}
        submenuArrow="right"
        onClick={() => onSelect(source)}
      >
        {source.name}
      </MenuOption>
    ))}
  </MenuGroupContent>
);
